import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wf93zqcct: FaireProductEntity = {
  token: "p_5wf93zqcct",
  type: "product",
  name: "TESTER -  Body & Room Myst - One (1)",
  brandToken: "b_we9tdmh5ka",
  brandName: "The Sacred Wild Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/bd4a510d9563fc45a46b2c6d5a8aab3441979ad70fe8bdbab827a019f0e24e7c.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.62,
  description:
    "This listing is for retailers who are ordering our mysts.   This listing is for ONE tester +++ please message us and let us know which one you'd like.   \n\nYou can purchase up to 5 (one of each scent) or just one, per year, but please message us and let us know which one(s) you'd like.      **PLEASE don't order these to sell as regular product - we have product listings for that...and as a maker on Faire, we need to say that with their commission, it's super hard to make it out here, and we know it is for small retailers too, so we TRY to keep our costs down, but margins are small!  thanks for supporting makers!  **   \nIf your shop sells these in larger quantities, please message us to communicate the need for more than 1 set per year.  thank you.  \n\n\n\n\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 15.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:20.827Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
